import { GridQuestion } from "./grid-question";
import type { QuestionTypeRendererProps } from "./shared";

type CheckboxGridQuestionProps = QuestionTypeRendererProps<"checkbox_grid">;

export default function CheckboxGridQuestionType(props: CheckboxGridQuestionProps) {
  return <GridQuestion {...props} kind="checkbox_grid" />;
}
